import { render, staticRenderFns } from "./index.vue?vue&type=template&id=650a94f8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650a94f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('650a94f8')) {
      api.createRecord('650a94f8', component.options)
    } else {
      api.reload('650a94f8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=650a94f8&scoped=true&", function () {
      api.rerender('650a94f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/reports/staticFx/index.vue"
export default component.exports